import {useProductOptions} from '@shopify/hydrogen';
import {useMemo} from 'react';
import {DurationIcon} from '~/components';

import {useShopifyProductVariant} from '~/hooks';

export function ProductDuration() {
  const {selectedVariant} = useProductOptions();
  const {data, isLoading} = useShopifyProductVariant({
    id: selectedVariant?.id ?? '',
  });
  const durationString = useMemo(() => {
    if (data && data?.duration) {
      const hours = Math.floor(data.duration / 60);
      const minutes = data.duration % 60;
      return `${hours > 0 ? `${hours}h` : ''}${
        minutes > 0 ? `${minutes}m` : ''
      }`;
    }

    return '';
  }, [data]);

  return !isLoading && data ? (
    <div className="flex items-center gap-1 text-black">
      <DurationIcon />
      <div>{durationString}</div>
    </div>
  ) : null;
}
